import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Profile from '../Profile'
import FashionProfile from '../../storefronts/indumentaria-femenina/FashionProfile'

function PublicProfile() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionProfile />
  }

  return <Profile />
}

export default PublicProfile
